import * as React from 'react';

import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { ModelData } from 'src/containers/ProjectDiagram/types/model';
import { clearDiagramUndoHistory } from 'src/containers/ProjectDiagram/utils/clearDiagramUndoHistory';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { createDraftData } from 'src/containers/ProjectDiagram/utils/draft/createDraftData';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useInitializeDraftData = () => {
  const diagram = useDiagram();
  const { projectId } = useRouterParams();

  return React.useCallback(() => {
    if (!diagram) {
      return;
    }

    if (!diagram.model.modelData.draftData) {
      clearDiagramUndoHistory(diagram, projectId);

      commitDiagramModel(diagram, (model) => {
        const draftData = createDraftData(model);
        setDataProperty<ModelData>(model)(
          model.modelData,
          'draftData',
          draftData
        );
      });
    }
  }, [diagram, projectId]);
};
